import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const HeaderWrapper = styled.header`
  background: linear-gradient(135deg, #148D89 0%, #1C64F2 100%);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 1000;
`;

const Nav = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  max-width: 1200px;
  margin: 0 auto;

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

const Logo = styled(Link)`
  font-size: 1.5rem;
  font-weight: 700;
  color: white;
  display: flex;
  flex-direction: column;
  line-height: 1.2;

  span {
    font-size: 0.9rem;
    font-weight: 400;
    opacity: 0.9;
  }
`;

const MenuButton = styled.button`
  display: none;
  background: none;
  border: none;
  color: white;
  font-size: 1.5rem;
  cursor: pointer;

  @media (max-width: 768px) {
    display: block;
  }
`;

const NavMenu = styled.ul<{ $isOpen: boolean }>`
  display: flex;
  gap: 2rem;
  align-items: center;

  @media (max-width: 768px) {
    position: fixed;
    top: 70px;
    left: 0;
    right: 0;
    background: linear-gradient(135deg, #148D89 0%, #1C64F2 100%);
    flex-direction: column;
    padding: 2rem;
    transform: ${props => props.$isOpen ? 'translateY(0)' : 'translateY(-100%)'};
    opacity: ${props => props.$isOpen ? '1' : '0'};
    pointer-events: ${props => props.$isOpen ? 'auto' : 'none'};
    transition: all 0.3s ease;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  }
`;

const NavItem = styled.li``;

const NavLink = styled(Link)`
  color: white;
  font-weight: 500;
  transition: opacity 0.3s ease;
  
  &:hover {
    opacity: 0.8;
  }
`;


const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <HeaderWrapper>
      <Nav>
        <Logo to="/">
          IGF
          <span>Institut Genevois de Formation</span>
        </Logo>
        
        <MenuButton onClick={() => setIsMenuOpen(!isMenuOpen)}>
          {isMenuOpen ? '✕' : '☰'}
        </MenuButton>
        
        <NavMenu $isOpen={isMenuOpen}>
          <NavItem>
            <NavLink to="/">Accueil</NavLink>
          </NavItem>
          <NavItem>
            <NavLink to="/secretaire-medical">Secrétaire Médicale</NavLink>
          </NavItem>
          <NavItem>
            <NavLink to="/assistant-medical">Assistant Médical</NavLink>
          </NavItem>
        </NavMenu>
      </Nav>
    </HeaderWrapper>
  );
};

export default Header;